module.exports = __webpack_public_path__ + "img/ArrowUpRight.a8d796f0.svg";